import { StandardEvents } from '@shopify/events';
// Reuse the native variant request: never introduce a second fetch or image gallery.
class FCProductImage extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.onSelect, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || !detail?.html) return;
      const next = [...detail.html.querySelectorAll('fc-product-image')].find(el => el.dataset.productId === this.dataset.productId);
      if (next) this.replaceWith(next);
    }).catch(error => { if (error?.name !== 'AbortError') console.warn('[fc-product-image] Variant image update failed:', error); });
  };
}
if (!customElements.get('fc-product-image')) customElements.define('fc-product-image', FCProductImage);
